import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { isValidBrowser } from '@utils/browserInfo';

export default function useBrowserSupport({ route }) {
  const routerRef = useRef(route);
  routerRef.current = useRouter();
  useEffect(() => {
    if (!isValidBrowser(window?.navigator.userAgent))
      routerRef.current.push('/browser');
  }, []);
  return null;
}
